import React from "react";
import { RankTable } from "../../../../../components";

const RankTableList = () => {
  return (
    <div className="my-5">
      <RankTable
        data={[
          { name: "person 3", count: 84 },
          { name: "person 2", count: 97 },
          { name: "person 1", count: 100 },
          { name: "person 4", count: 77 },
          { name: "person 5", count: 62 },
          { name: "person 6", count: 55 },
          { name: "person 7", count: 48 },
        ]}
      />
    </div>
  );
};

export default RankTableList;
